<template>
  <section v-if="front.showPageMasthead" class="page-masthead">
    <nav class="breadcrumb" aria-label="面包屑">
      <template v-for="(item, index) in front.breadcrumbTrail">
        <span
          v-if="index > 0"
          :key="'sep-' + index"
          class="breadcrumb-sep"
          aria-hidden="true"
        >›</span>
        <button
          v-if="item.path && !item.current"
          :key="'crumb-' + index"
          type="button"
          class="breadcrumb-link"
          @click="front.goPath(item.path)"
        >
          <span v-if="index === 0" class="breadcrumb-home-ico" aria-hidden="true" v-html="homeIcon" />
          <span>{{ item.label }}</span>
        </button>
        <strong
          v-else
          :key="'crumb-' + index"
          class="breadcrumb-current"
          aria-current="page"
        >
          <span v-if="index === 0" class="breadcrumb-home-ico" aria-hidden="true" v-html="homeIcon" />
          <span>{{ item.label }}</span>
        </strong>
      </template>
    </nav>
    <h1 v-if="!front.hidePageMainTitle">{{ front.pageTitle }}</h1>
    <p v-if="front.pageSubtitle && !front.isPartyPage" class="page-masthead-subtitle">{{ front.pageSubtitle }}</p>
  </section>
</template>

<script>
const homeIcon = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>'

export default {
  name: 'PageMasthead',
  inject: ['front'],
  data() {
    return { homeIcon }
  }
}
</script>
